/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CheckSquareOffset(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M203.99951,36.00012h-152a16.01834,16.01834,0,0,0-16,16v91.27246a8,8,0,0,0,16,0V52.00012h152v152H135.63525a8,8,0,0,0,0,16h68.36426a16.01833,16.01833,0,0,0,16-16v-152A16.01833,16.01833,0,0,0,203.99951,36.00012Z" />
        <Path d="M133.65674,146.34338a8.00121,8.00121,0,0,0-11.31445,0L63.99951,204.68664,37.65674,178.34338a8.00018,8.00018,0,1,0-11.31445,11.31348l32,32a8.00062,8.00062,0,0,0,11.31445,0l64-64A8,8,0,0,0,133.65674,146.34338Z" />
      </G>
    </Svg>
  );
}

export default CheckSquareOffset;
